import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';

import { actions as PosCartActions } from '../constants/PosCartConstants';

import { events as PosCartEvents } from '../constants/PosCartConstants';

import PosStore from './PosStore';
import UserStore from './UserStore';
import * as _ from 'lodash';
var _state = {
    cart                    : [],
    preOrders               : [],
    allotment               : [],
    appliedDiscounts        : [],
    appliedFeesDonations    : [],
    selected                : false,
    loyaltyApplied          : 0,
    payment                 : {},
    lastUpdated             : 0,
    loading                 : false,
    subTotal                : 0,
    totalDiscountAndLoyalty : 0,
    tax                     : 0,
    feesAndDonations        : 0,
    grandTotal              : 0,
    grandTotalRounded       : 0,
    totalItems              : 0,
    remotePayInfo           : false,  
    prepayInfo              : false,
    isPreauth               : false,
    TipAmount               : null,
    StatefulCheckoutTotalCalculated: false,  
};

class PosCartStoreClass extends EventEmitter {

    constructor() {
        super();
        this.filterPreorders = this.filterPreorders.bind(this);
    }

    getState() {
        return _state;
    }

    filterPreorders(preOrders, cart) {
        var cartArr = _.cloneDeep(cart);
        for (var i = 0; i< preOrders.length; i++) {
            var cartItems = _.filter(cartArr, x => x.ProductId === preOrders[i].ProductId);
            for (var j = 0; j < cartItems.length; j++) {
                if (cartItems[j] && cartItems[j].WgtCnt && cartItems[j].WgtCnt.toLowerCase() === 'wgt') {
                    var toSubtract = Math.min(cartItems[j].Grams, preOrders[i].Grams);
                    preOrders[i].Grams -= toSubtract;
                    cartArr[cartItems[j].Id-1].Grams -= toSubtract;
                    
                    
                } else {
                    var toSubtract = Math.min(cartItems[j].QtySelected, preOrders[i].QtySelected);
                    cartArr[cartItems[j].Id-1].QtySelected -= toSubtract;
                    preOrders[i].QtySelected -= toSubtract;
                }
                
            }
        }
        return _.filter(preOrders, x => (x.UnitId == 1 && x.QtySelected > 0) ||  (x.UnitId != 1 && x.Grams > 0)) ;
    }

    cartTotalCalculated(data) {
        _state.appliedDiscounts = data.appliedDiscounts;
        _state.appliedFeesDonations = data.appliedFeesDonations;
        _state.loyaltyApplied = data.loyalty;
        _state.totalDiscountAndLoyalty = data.TotalDiscountAndLoyalty;
        _state.tax = data.Tax;
        _state.feesAndDonations = data.FeesAndDonations;
        _state.grandTotalRounded = data.GrandTotalRounded;
        _state.totalDiscount = data.TotalDiscount;
        _state.subTotal = data.SubTotal;
        _state.StatefulCheckoutTotalCalculated = true;
        _state.RoundingAmount = data.RoundingAmount;
        _state.payment = data.payment;
        _state.TipAmount = data.TipAmount;
        this.emitChange();
    }

    onJoryPayment(electronicPaymentPayload) {
        _state.TipAmount = electronicPaymentPayload.TipAmount;
        _state.payment.ElectronicAmount = electronicPaymentPayload.DebitPaid;
        _state.payment.ElectronicType = 'jory';
        this.emitChange();
    }

    userCartLoaded(data) {
        if(data.timestamp > _state.lastUpdated) {
            _state.cart = data.cart;
            _state.preOrders = this.filterPreorders(data.preOrders, _state.cart);
            _state.allotment = data.allotment;
            _state.lastUpdated = data.timestamp;
            _state.payment = data.payment;
            _state.totalItems = data.TotalItems;
            _state.remotePayInfo = data.remotePayInfo;
            _state.prepayInfo = data.prepayInfo;
            _state.isPreauth = data.isPreauth;
            _state.subTotal = data.SubTotal;
            _state.StatefulCheckoutTotalCalculated = false;
            _state.appliedDiscounts = data.appliedDiscounts;
            if (!UserStore.getState().selectedLocation.StatefulCheckout) {
                _state.grandTotal = data.GrandTotal;
                _state.grandTotalRounded = data.GrandTotalRounded;
                _state.appliedFeesDonations = data.appliedFeesDonations;
                _state.loyaltyApplied = data.loyalty;
                _state.totalDiscountAndLoyalty = data.TotalDiscountAndLoyalty;
                _state.tax = data.Tax;
                _state.feesAndDonations = data.FeesAndDonations;
                _state.totalDiscount = data.TotalDiscount;
                _state.RoundingAmount = data.RoundingAmount;
                _state.TipAmount = data.TipAmount;
            }
            this.emitChange();
        }
    }
    remotePayStatusLoaded(data) {
        _state.remotePayInfo = data.remotePayInfo;
        this.emitChange();
    }

    allotmentLoaded(data) {
        _state.allotment = data;
        this.emitChange();
    }

    setPaymentData(payment) {
        _state.payment = payment;
    }
  
    clearCart() {
        _state = {
            cart             : [],
            preOrders        : [],
            allotment        : [],
            appliedDiscounts : [],
            appliedFeesDonations : [],
            selected         : false,
            loyaltyApplied   : 0,
            lastUpdated: 0,
        };
        this.emitChange();
    }

    getAllotment(guest) {
        if (!guest) {
            return { total : 0, remaining : 0, cart : 0, details : [] };
        }

        return {
            total: _state.allotment.CurrentAllotmentOverriden ? _state.allotment.CurrentLimitOverride : _state.allotment.TotalLimit,
            remaining: _state.allotment.TotalRemaining,
            cart: _state.allotment.TotalInCart,
            used: _state.allotment.TotalUsed,
            details: _state.allotment.Details,
        };
    }

    getPaymentData() {
        return _state.payment || {};
    }

    getCartSummary() {
        return {
            subTotal       :  this.splitPrice((!!_state.subTotal ?_state.subTotal : 0).toFixed(2)),
            total          :  this.splitPrice((!!_state.grandTotal ? _state.grandTotal : 0).toFixed(2)),
            tax            :  this.splitPrice((!!_state.tax ? _state.tax : 0).toFixed(2)),
            discount       : this.splitPrice((!!_state.totalDiscountAndLoyalty ? _state.totalDiscountAndLoyalty : 0).toFixed(2)),
            roundedDown    : this.splitPrice((!!_state.grandTotalRounded ? _state.grandTotalRounded: 0).toFixed(2)),
            appliedFDsAmt  : this.splitPrice((!!_state.feesAndDonations ? _state.feesAndDonations : 0).toFixed(2)),
            loyaltyApplied : _state.loyaltyApplied,
            totalItems     : _state.totalItems,
            totalDiscount  : _state.totalDiscount,
            StatefulCheckoutTotalCalculated : !UserStore.getState().selectedLocation.StatefulCheckout || _state.StatefulCheckoutTotalCalculated,
            roundingAmount     : this.splitPrice((!!_state.RoundingAmount ? _state.RoundingAmount : 0).toFixed(2)),
            TipAmount      : this.splitPrice((!!_state.TipAmount ? _state.TipAmount : 0).toFixed(2)),
            prepayInfo: _state.prepayInfo,
            isPreauth: _state.isPreauth,
        };
    }

    // expecting string
    splitPrice(val) {
        return {
            str : val,
            int : parseInt(val.replace('.', '')),
            flt : parseFloat(val)
        }
    }

    getQtyInCartBySerialNo(serialNo) {
        for (var i=0; i<_state.cart.length; i++) {
            if (_state.cart[i].SerialNo == serialNo) {
                return _state.cart[i].QtyAllocated;
            }
        }

        return false;
    }

    getItemBySerialNo(serialNo) {
        for (var i=0; i<_state.cart.length; i++) {
            if (_state.cart[i].SerialNo == serialNo) {
                return _state.cart[i];
            }
        }

        return false;
    }

    emitChange(callback) {
        this.emit(PosCartEvents.CHANGE_EVENT, callback);
    }

    addChangeListener(callback) {
        this.on(PosCartEvents.CHANGE_EVENT, callback);
    }

    removeChangeListener( callback ) {
        this.removeListener(PosCartEvents.CHANGE_EVENT, callback);
    }
}

const PosCartStore = new PosCartStoreClass();

PosCartStore.dispatchToken = AppDispatcher.register(action => {
    switch(action.actionType) {
    case PosCartActions.START_LOAD:
        _state.loading = true;
        PosCartStore.emitChange();
        break;

    case PosCartActions.END_LOAD:
        _state.loading = false;
        PosCartStore.emitChange();
        break;

    case PosCartActions.CART_TOTAL_CALCULATING:
        _state.loading = true;
        PosCartStore.emitChange();
        break;

    case PosCartActions.USER_CART_LOADED:
        _state.loading = false;
        PosCartStore.userCartLoaded(action);
        break;

    case PosCartActions.CART_TOTAL_FAILED:
        _state.loading = false;
        PosCartStore.emitChange();
        break;

    case PosCartActions.CART_TOTAL_CALCULATED:
        _state.loading = false;
        PosCartStore.cartTotalCalculated(action);
        break;

    case PosCartActions.REMOTE_PAY_STATUS_LOADED:
        PosCartStore.remotePayStatusLoaded(action);
        break;

    case PosCartActions.ALLOTMENT_LOADED:
        PosCartStore.allotmentLoaded(action.data);
        break;

    case PosCartActions.PRE_ORDERS_LOADED:
        _state.preOrders = PosCartStore.filterPreorders(action.data, _state.cart);
        PosCartStore.emitChange();
        break;
    }
});

export default PosCartStore;



// WEBPACK FOOTER //
// ./ui_src/app/stores/PosCartStore.jsx